<template>
  <div class="main">
    <report-top><template slot="search">
        <ly-search v-model="searchItem.keyword" @search="search"></ly-search> </template></report-top>
    <div id="formTable">
      <div id="text">
        当前位置：<a @click="home">一级单位</a><a style="margin-right: 4px" v-for="(item, index) in mianbao" :key="index"
          @click="back(item, index)">
          <Icon type="ios-arrow-forward" />{{ item.name }}
        </a>
      </div>
      <div id="ddas">
        <Button @click="getDeList">标签</Button>
        <Button @click="openaddparent" type="primary">新增</Button>
      </div>
    </div>
    <Table :data="tableData" :columns="columns" stripe ref="table" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)" @on-selection-change="selectCars = $event">
      <template slot-scope="{ row, index }" slot="title">
        <span @click="chakanxiaji(row)">
          <Icon type="ios-arrow-forward" v-show="row.childList.length > 0" />
          <a v-show="row.childList.length > 0">{{ row.name }}</a>
          <span v-show="row.childList.length == 0">{{ row.name }}</span>
        </span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openAdd(row)">新增</Button>
        <Button size="small" @click="openUpdate(row)">编辑</Button>
        <Button size="small" @click="del(row)">删除</Button>
      </template>
    </Table>
    <form-model :title="modalTitle" width="700" ref="formModel">
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <carLabel ref="carLabel" @labelSaveFinish="getList"></carLabel>
  </div>
</template>
<script>
import axios from "axios";
import carLabel from "./groupLabel.vue";
export default {
  components: { carLabel },
  data() {
    return {
      isAdd: true,
      modalTitle: "",
      columns: [
        {
          type: "selection",
          width: 70,
          align: "center",
          sort: 0
        },
        {
          title: "创建者账号",
          key: "createAccount",
          sort: 20
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          sort: 20
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          sort: 20
        },
      ],
      tableData: [],
      mianbao: [],
      item: {
        name: "",
        sort: 1,
        charge: "",
        contact: "",
        pid: 0,
        remark: "",
        //type: "",
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        sort: { required: true, message: "必填" },
      },
      searchItem: {
        keyword: "",
      },
      forms: [
        {
          title: "单位名称",
          slot: 'title',
          key: "name",
          key1: "name",
          multiple: true,
          type: "Input",
          required: true,
          maxWidth: 300,
          minWidth: 200
        },
        {
          title: "排序",
          key: "sort",
          key1: "sort",
          multiple: true,
          type: "InputNumber",
          required: true,
        },
        {
          title: "负责人",
          key: "charge",
          key1: "charge",
          type: "Input",
        },
        {
          title: "联系方式",
          key: "contact",
          key1: "contact",
          multiple: true,
          type: "Input",
        },
        {
          title: "备注信息",
          key: "remark",
          key1: "remark",
          type: "Input",
          type1: "textarea",
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.bm + "/group/tree",
        data: this.searchItem,
      }).then((res) => {

        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        var that = this;
        function menu(t) {


          for (let i = 0; i < t.length; i++) {

            that.autoUpdate(t[i]);
            if (t[i].childList.length > 0) {
              menu(t[i].childList);
            }
          }
          return t;
        }
        this.treeData = menu(data);
        if (this.mianbao.length == 0) {
          this.tableData = this.treeData;
        }
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.bm + "/group/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.bm + "/group/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    del(row) {
      let params = { idList: [row.id] };
      this.$Modal.confirm({
        title: "确定要删除【" + row.name + "】单位/功能？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.bm + "/group/del",
            data: params,
          }).then((res) => {
            if (res) {
              this.openForm = false;
              this.getList();
            }
          });
        },
      });
    },
    openaddparent() {
      if (this.mianbao.length == 0) {

        this.isAdd = true;
        this.item.pid = 0;
        this.modalTitle = "新增一级单位";
        this.$refs.formModel.reach(this.forms, this.item);
      } else {
        this.openAdd(this.mianbao[this.mianbao.length - 1]);
      }
    },
    openAdd(row) {
      this.isAdd = true;
      this.item.pid = row.id;
      this.modalTitle = "新增【" + row.name + "】下级单位";
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openUpdate(row) {
      this.modalTitle = "编辑【" + row.name + "】单位";
      this.isAdd = false;
      this.item = row;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    //新的
    chakanxiaji(item) {
      if (item.childList.length == 0) {
        return;
      }
      this.tableData = item.childList;
      this.mianbao.push(item);
    },
    back(item, index) {
      this.tableData = item.childList;
      this.mianbao.splice(index + 1, this.mianbao.length - (index + 1));
      //长度3 当前index0 删除位置1 删除个数2
      //长度3 当前index1 删除位置2 删除个数1
      //长度4 当前index0 删除位置1 删除个数3
      //长度4 当前index1 删除位置2 删除个数2
      //长度4 当前index2 删除位置3 删除个数1
    },
    home() {
      this.getList();
      this.mianbao = [];
    },
    autoUpdate(gold) {
      if (this.mianbao.length > 0) {
        var aa = this.mianbao[this.mianbao.length - 1].id;
        if (gold.id == aa) {
          this.tableData = gold.childList;
        }
      }
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    search() {
      this.home();
    },
    //多选模式下。将选中的放到deList里边,目前批量转移接用
    getDeList(y) {
      var x = this.selectCars;
      if (x.length == 0) {
        this.$Message.error("至少选择一台车");
        return;
      }
      if (y == 1) {
        this.openTransferForm = true;
      } else {
        this.$refs.carLabel.reachData(x);
      }
    },

  },
  mounted() {
    this.getList();
    this.columns = this.utils.cols(this.forms, this.columns);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/information/group.vue